
import Orleans81 from './Orleans 8 (1).webp'
import Orleans82 from './Orleans 8 (2).webp'
import Orleans83 from './Orleans 8 (3).webp'
import Orleans84 from './Orleans 8 (4).webp'
import Orleans85 from './Orleans 8 (5).webp'
import Orleans86 from './Orleans 8 (6).webp'
import Orleans87 from './Orleans 8 (7).webp'
import Orleans88 from './Orleans 8 (8).webp'
import Orleans89 from './Orleans 8 (9).webp'
import Orleans810 from './Orleans 8 (10).webp'


const Orleans8images =[
Orleans81,Orleans82,Orleans83,Orleans84,Orleans85,Orleans86,Orleans87,Orleans88,Orleans89,Orleans810
]

export default Orleans8images;